import React from 'react';
import { CockpitButton, CockpitButtonProps } from 'components/views/atoms/CockpitButton';
import { faPhoneAlt, faPhoneSquareAlt, faPhoneSlash, faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
import { keyframes } from '@emotion/react';

export type TelephoneState = 'ready' | 'ringing' | 'calling' | 'talking' | 'disabled';

export type TelephoneButtonProps = Omit<CockpitButtonProps, 'icon'> & {
    state: TelephoneState;
}

const ringing = keyframes({
    from: {
        color: 'red',
    },
    to: {
        color: 'white',
    }
});

function iconFromState(state: TelephoneState) {
    switch (state) {
        case 'ready':
            return { icon: faPhoneAlt };
        case 'ringing':
            return { icon: faPhoneSquareAlt, color: 'red', animation: `${ringing} 1s ease alternate infinite` };
        case 'calling':
            return { icon: faPhoneSquareAlt };
        case 'talking':
            return { icon: faPhoneVolume };
        case 'disabled':
            return { icon: faPhoneSlash, flip: true };
    }
}

export const TelephoneButton = (props: TelephoneButtonProps) => {
    const { state, ...otherProps } = props;

    const { icon, color, flip = false, animation } = iconFromState(state);

    return (
        <CockpitButton icon={icon} color={color} flip={flip} animation={animation} {...otherProps} />
    );
};
